/**
 * 绑定任一账号前都不能信任已有的同步状态：Safari 可能丢失 localStorage 的账号标识，
 * 但仍保留 IndexedDB/cursor。首个登录账号也必须从服务端完整恢复，防止旧缓存回推。
 */
export function shouldResetSyncForAccount(previousUsername: string | null, nextUsername: string): boolean {
  return previousUsername !== nextUsername;
}
